import { FormatOptions } from '@/components/AnalyticsDashboard/formatter'

export const formatPercent: FormatOptions = {
  format: { type: 'intl-number', maximumFractionDigits: 1, style: 'percent' },
  steps: [{ format: { type: 'locale-format-string', format: { sv: '%s', en: '%s' } } }]
}

export const formatPercentRounded: FormatOptions = {
  format: { type: 'intl-number', maximumFractionDigits: 0, style: 'percent' },
  steps: [{ format: { type: 'locale-format-string', format: { sv: '%s', en: '%s' } } }]
}

export const formatCount: FormatOptions = {
  format: { type: 'intl-number', maximumFractionDigits: 0 },
  steps: [{ format: { type: 'locale-format-string', format: { sv: '%s', en: '%s' } } }]
}

export const formatArea: FormatOptions = {
  format: { type: 'intl-number', maximumFractionDigits: 0 },
  steps: [{ format: { type: 'locale-format-string', format: { sv: '%s m²', en: '%s m²' } } }]
}
